








import { Component } from 'vue-property-decorator'
import ViewBase from '@/utils/ViewBase.ts'
import enquireScreen from './utils/index'
import zhCN from 'ant-design-vue/lib/locale-provider/zh_CN'
import moment from 'moment'
import 'moment/locale/zh-cn'
moment.locale('zh-cn')

@Component
export default class App extends ViewBase {
  zhCN: any = zhCN

  created() {
    enquireScreen((isMobile: any) => {
      this.$store.commit('setting/setDevice', isMobile)
    })
  }

  key() {
    return this.$route.path + Math.random()
  }
}
